<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/inventory/purchase">Purchase</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
      </b-row>
      <div class="border-bottom"></div>
      <div v-if="isLoading" class="justify-content-center">
        <div
          class="text-center justify-items-center justify-content-center spinner-position"
          style="margin: 10% auto;"
        >
          <b-spinner small type="grow" label="Small Spinner"></b-spinner>
          <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
          <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
        </div>
      </div>
      <div v-else>
        <b-row>
          <b-col md="5">
            <b-row class="mt-3">
              <b-col md="4"><label class="labels">purchase id</label></b-col>
              <b-col md="3"> {{ detail.purchaseId }}</b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="4"><label class="labels">purchase date</label></b-col>
              <b-col md="4"> {{ getDateTime(detail.purchaseDate) }}</b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="4"><label class="labels">bank account</label></b-col>
              <b-col md="4"> {{ detail.bankAccount }}</b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="4"><label class="labels">supplier</label></b-col>
              <!-- <b-col md="1"></b-col> -->
              <b-col md="3"> {{ detail.supplier }}</b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col md="4"><label class="labels">supplier</label></b-col>
              <!-- <b-col md="1"></b-col> -->
              <b-col md="4"> {{ detail.supplier }}</b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col md="4"><label class="labels">Note</label></b-col>
              <b-col md="4" style="white-space: pre-line;"> {{ detail.purchaseNote }}</b-col>
            </b-row>
          </b-col>
          <b-col md="7" class="mt-2">
            <b-card>
              <h5 class="text-bold">History Payment</h5>
              <b-table
                id="my-table"
                :items="detail.purchaseHistoryPayment"
                :fields="history"
                center
                show-empty
                class="text-left"
              >
                <template #cell(paymentDate)="row">
                  <div class="text-left">
                    {{ row.item.paymentDate !== null ? getDateTime(row.item.paymentDate) : '-' }}
                  </div>
                </template>
                <template v-slot:cell(paymentAmmount)="row">
                  {{ dataAccount.account.currency }}
                  {{ row.item.paymentAmmount !== null ? formatNumber(row.item.paymentAmmount) : 0 }}
                </template>
                <template v-slot:cell(paymentReceipt)="row">
                  <viewer>
                    <b-row>
                      <b-col md="3">
                        <p
                          class="text-secondary text-center d-flex"
                          v-if="row.item.paymentReceipt === null"
                        >
                          <i>No Photo Submitted</i>
                        </p>
                        <b-img
                          v-else
                          :src="row.item.paymentReceipt"
                          v-b-tooltip.focus
                          class="img-responsive border-radius"
                          width="30"
                          height="30"
                        />
                      </b-col>
                    </b-row>
                  </viewer>
                </template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <b-table
              id="my-table"
              :items="detail.purchaseItem"
              :fields="fields"
              responsive
              center
              show-empty
              class="text-left mt-4 mb-5 justify-content-center"
            >
              <template v-slot:cell(price)="row">
                {{ dataAccount.account.currency }}
                {{ row.item.price !== null ? formatNumber(row.item.price) : 0 }}
              </template>
              <template v-slot:cell(subTotal)="row">
                {{ dataAccount.account.currency }}
                {{ row.item.subTotal !== null ? formatNumber(row.item.subTotal) : 0 }}
              </template>
              <template v-slot:cell(discount)="row">
                {{ row.item.discount === 0 ? '-' : row.item.discount }}
              </template>
              <template v-slot:cell(totalDiscount)="row">
                {{ dataAccount.account.currency }}
                {{ row.item.totalDiscount === 0 ? '-' : formatNumber(row.item.totalDiscount) }}
              </template>
              <template v-slot:cell(totalPriceAfterDiscount)="row">
                {{ dataAccount.account.currency }}
                {{
                  row.item.totalPriceAfterDiscount !== 0
                    ? formatNumber(row.item.totalPriceAfterDiscount)
                    : 0
                }}
              </template>
              <template v-slot:cell(totalPriceAfterTax)="row">
                {{ dataAccount.account.currency }}
                {{
                  row.item.totalPriceAfterTax !== null
                    ? formatNumber(row.item.totalPriceAfterTax)
                    : 0
                }}
              </template>
            </b-table>
          </b-col>
        </b-row>
        <div>
        
          <b-row class="mt-3">
            <b-col md="4"><label class="labels">Total Discount (All Item)</label></b-col>
            <!-- <b-col md="1"></b-col> -->
            <b-col md="4">
              {{ dataAccount.account.currency }} {{ formatNumber(detail.purchaseTotalDiscount) }}
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="4"><label class="labels">Purchase Total</label></b-col>
            <!-- <b-col md="1"></b-col> -->
            <b-col md="4" class="text-success font-weight-bold">
              {{ dataAccount.account.currency }} {{ formatNumber(detail.purchaseTotal) }}
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="4"><label class="labels">Total Payment</label></b-col>
            <!-- <b-col md="1"></b-col> -->
            <b-col md="4" class="text-primary">
              {{ dataAccount.account.currency }} {{ formatNumber(detail.purchaseTotalPayment) }}
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="4"><label class="labels">Unpaid Bill</label></b-col>
            <!-- <b-col md="1"></b-col> -->
            <b-col md="4">
              {{ dataAccount.account.currency }} {{ formatNumber(detail.purchaseUnpaidBill) }}
            </b-col>
          </b-row>
        </div>

        <b-button class="mt-5 mb-5" @click="goBack()" variant="secondary"
          ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
        >
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      dataAccount: this.$store.getters['account/accountData'],
      apiUrl: {
        purchase: window.AppConfig.apiUrl + 'purchase',
      },
      detail: {
        purchaseId: null,
        supplier: null,
        taxValue: null,
        purchaseItem: null,
        purchaseHistoryPayment: null,
        purchaseDate: null,
        purchaseNote: null,
        bankAccount: null,
        createdAt: null,
        createdBy: null,
        purchaseStatus: null,
        purchaseTotal: 0,
        purchaseTotalPayment: 0,
        purchaseUnpaidBill: 0,
        purchaseTotalDiscount: 0,
      },
      fields: [
        {
          key: 'itemList.name',
          label: 'Item',
          class: 'w-25',
        },
        {
          key: 'quantity',
          label: 'Qty',
          class: 'text-center',
        },
        {
          key: 'price',
          label: 'Price',
          class: 'text-right',
        },
        {
          key: 'discount',
          label: 'Discount(%) / item',
          class: 'text-center',
        },
        {
          key: 'subTotal',
          label: 'Subtotal',
          class: 'text-center',
        },
        {
          key: 'totalDiscount',
          label: 'Total Discount / item',
          class: 'text-right',
        },
        {
          key: 'totalPriceAfterDiscount',
          label: 'Total Price After Discount',
          class: 'text-right',
        },
        //  {
        //     key: 'taxValue',
        //     label: 'Tax (%)',
        //     class: 'text-center'
        // },
        {
          key: 'totalPriceAfterTax',
          label: 'Total Price After Tax',
          class: 'text-right',
        },
      ],
      history: [
        {
          key: 'paymentDate',
          label: 'Date',
        },
        {
          key: 'paymentRefNumber',
          label: 'Payment Ref',
        },
        {
          key: 'paymentAmmount',
          label: 'Payment Ammount',
        },
        {
          key: 'paymentTo.bank',
          label: 'Payment to',
        },
        {
          key: 'paymentReceipt',
          label: 'Photo',
        },
      ],
    };
  },

  mounted() {
    this.initData();
  },

  methods: {
    initData() {
      if (this.$route.params !== undefined) {
        this.getDetails();
      }
    },

    getDetails() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.purchase + '/' + this.$route.params.uuid)
        .then((response) => {
          this.detail.purchaseId =
            response.data.purchaseId !== null ? response.data.purchaseId : '-';
          this.detail.supplier =
            response.data.supplier !== null ? response.data.supplier.name : '-';
          this.detail.taxValue = response.data.taxValue !== null ? response.data.taxValue : '-';
          this.detail.purchaseDate =
            response.data.purchaseDate !== null ? response.data.purchaseDate : '-';
          this.detail.purchaseNote =
            response.data.purchaseNote !== null ? response.data.purchaseNote : '-';
          this.detail.bankAccount =
            response.data.bankAccount !== null ? response.data.bankAccount.bank : '-';
          this.detail.createdAt = response.data.createdAt !== null ? response.data.createdAt : '-';
          this.detail.createdBy = response.data.createdBy !== null ? response.data.createdBy : '-';
          this.detail.purchaseStatus =
            response.data.purchaseStatus !== null ? response.data.purchaseStatus : '-';
          this.detail.purchaseTotal =
            response.data.purchaseTotal !== 0 ? response.data.purchaseTotal : 0;
          this.detail.purchaseTotalPayment =
            response.data.purchaseTotalPayment !== 0 ? response.data.purchaseTotalPayment : 0;
          this.detail.purchaseUnpaidBill =
            response.data.purchaseUnpaidBill !== 0 ? response.data.purchaseUnpaidBill : 0;
          this.detail.purchaseTotalDiscount =
            response.data.purchaseTotalDiscount !== 0 ? response.data.purchaseTotalDiscount : 0;

          this.detail.purchaseHistoryPayment = [];
          if (response.data.purchaseHistoryPayment !== null) {
            response.data.purchaseHistoryPayment.forEach((data) => {
              this.detail.purchaseHistoryPayment.push(data);
            });
          }

          this.detail.purchaseItem = [];
          if (response.data.purchaseItem !== null) {
            response.data.purchaseItem.forEach((data) => {
              this.detail.purchaseItem.push(data);
            });
          }
          setTimeout(() => {
            this.isLoading = false;
          }, 800);
          console.log(this.detail.purchaseHistoryPayment);
        })
        .catch((error) => {
          this.$store.dispatch('notification/error', error);
          this.isLoading = false;
        });
    },

    /**
     * formatter currency untuk data static
     */
    formatNumber(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('DD/MM/YYYY');
      } else {
        return '-';
      }
    },

    goBack() {
      window.goBack(this);
    },
  },
};
</script>

<style></style>
